import React from "react";
import { useNavigate } from "react-router-dom";
import LoadingSkeleton from "../general/skeleton";
import clsx from "clsx";

export const SlimCard = ({ data, loading, className, hidden }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!data.action) return;
    
    if (typeof data.action === "string") {
      // If action is a URL, navigate to it
      if (data.action.startsWith("http")) {
        window.location.href = data.action;
      } else {
        navigate(data.action);
      }
    } else if (typeof data.action === "function") {
      // If action is a function, execute it
      data.action();
    }
  };

  return (
    <LoadingSkeleton loading={loading} className={clsx("h-[120px]", className)}>
<div
  className={clsx(
    "min-h-[100px] max-w-4xl flex-1 relative px-3 py-2 rounded-2xl font-nexa flex flex-col justify-center items-center overflow-hidden",
    data.bgColor ? data.bgColor : "bg-white",
    data.action && "cursor-pointer hover:opacity-80"
  )}
  onClick={handleClick}
>
  <div className="flex justify-between items-center w-full">
    <div className="flex flex-col flex-1">
      {data.title && (
        <p className="font-nexa text-sm sm:text-xs md:text-sm text-primary-title leading-snug mb-2">
          {data.title}
        </p>
      )}
      {data.value && (
        <p className={`font-nexa font-bold text-sm sm:text-md md:text-lg text-primary-dark leading-none m-0 ${hidden && "blur-sm"}`}>
          {data.value}
        </p>
      )}
      {data.desc && (
        <p className="font-nexa font-normal text-xs sm:text-sm md:text-base text-subText leading-none">
          {data.desc}
        </p>
      )}
    </div>

    {data.icon && (
      <div className="flex rounded-xl bg-primary-title p-2 items-center">
        <data.icon className="text-primary-light text-lg sm:text-xl md:text-2xl" />
      </div>
    )}
  </div>
</div>

    </LoadingSkeleton>
  );
};